const carList = $("#car-list");

export function setLoadingCards(loadType = "next") {
  const loadingCardsContainer = $("<div></div>").addClass(
    "columns is-multiline is-mobile mt-4 loading-card"
  );
  for (let index = 0; index < 6; index++) {
    loadingCardsContainer.append(loadingCardComponent());
  }
  if (loadType == "next") {
    carList.append(loadingCardsContainer);
  } else {
    carList.prepend(loadingCardsContainer);
  }
}

function removeLoadingCards() {
  $(".loading-card").remove();
}

function loadingCardComponent() {
  return `
      <div class="column is-4-desktop is-6-tablet is-12-mobile loading-card">
      <div id="card-data" class="card card--car p-0">
        <div class="columns is-mobile is-multiline">
          <div class="column is-12 pt-0">
            <div class="skeleton skeleton-rect" style="
                        --rect-h: 190px;
                        --l-h: 40px;
                        --lines: 1;
                    "></div>
            <div class="skeleton skeleton-line" style="--l-h: 40px;"></div>
            <div class="skeleton skeleton-line" style="
                        --c-bg: #F8F7FC;
                        --lines: 5;
                    "></div>
            <div class="skeleton skeleton-line my-3" style="--l-h: 40px;"></div>
          </div>
        </div>
      </div>
    </div>
    `;
}

export function updateRelTags(currentPage, totalPages) {
  const head = document.querySelector("head");
  let prevLink = document.querySelector('link[rel="prev"]');
  let nextLink = document.querySelector('link[rel="next"]');
  let canonicalLink = document.querySelector('link[rel="canonical"]');

  const linkRel = new URL(location.href);

  canonicalLink.href = linkRel.toString();

  if (currentPage > 1) {
    if (!prevLink) {
      prevLink = document.createElement("link");
      prevLink.rel = "prev";
      head.appendChild(prevLink);
    }
    linkRel.searchParams.set("page", currentPage - 1);
    linkRel.toString();
    prevLink.href = linkRel;
  } else if (prevLink) {
    prevLink.remove();
  }

  if (currentPage < totalPages) {
    if (!nextLink) {
      nextLink = document.createElement("link");
      nextLink.rel = "next";
      head.appendChild(nextLink);
    }
    linkRel.searchParams.set("page", currentPage + 1);
    linkRel.toString();
    nextLink.href = linkRel;
  } else if (nextLink) {
    nextLink.remove();
  }
}

export function updateQueryString(key, value) {
  const url = new URL(window.location);
  if (value) {
    url.searchParams.set(key, value);
  } else {
    url.searchParams.delete(key);
  }
  history.pushState(null, "", url);
}

export async function fetchMoreCards(endpoint, page, loadType = "next") {
  try {
    const response = await fetch(endpoint);
    const data = await response.json();
    removeLoadingCards();

    const group = $("<div></div>");
    group.addClass("columns is-multiline is-mobile mt-4");
    group.attr("data-page", page);

    data.carComponents.forEach((carComponent) => {
      group.append(carComponent);
    });
    loadType == "next" ? carList.append(group) : carList.prepend(group);

    updateRelTags(page, data.total_pages);

    const pageDiv = document.querySelector("[data-page]");
    if (document.documentElement.scrollTop <= pageDiv.offsetHeight) {
      page == 1
        ? updateQueryString("page", null)
        : updateQueryString("page", page);
    }
    updatepageObservers();
  } catch (error) {
    console.error("Error:", error);
    carList.empty();
    $('#load-more-div-top').addClass('is-hidden');
    $('#load-more-div-bottom').addClass('is-hidden');
    carList.append(`<div class="column is-12" style="text-align: center;">
        <p class="has-text-weight-bold">No cars available.</p>
      </div>`);
  }
}

export function updatepageObservers() {
  const pagesDivs = document.querySelectorAll("[data-page]");

  pagesDivs.forEach((pageDiv) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const dataPage = entry.target.getAttribute("data-page");
            dataPage == 1
              ? updateQueryString("page", null)
              : updateQueryString("page", dataPage);
            updateRelTags(+dataPage, totalPages);
          }
        });
      },
      {
        rootMargin: getRootMargin(),
        threshold: 0.01,
      }
    );

    observer.observe(pageDiv);
  });
}

function getRootMargin() {
  if (window.innerWidth < 1215) {
    return "-300px 0px -300px 0px";
  } else {
    return "-400px 0px -400px 0px";
  }
}


window.addEventListener('resize', () => {
  updatepageObservers();
});

export function setMakeModel(urlParams) {
  const isGeo = $(".sortby__btn, .sortby-mobile").data("geo");
  const segments = window.location.pathname.split("/").slice(2);
  const make = segments.shift();
  
  urlParams.set("make", make);

  let model = '';

  if (isGeo || segments.length === 1) {
    model = segments.pop();
    urlParams.set("model", model);
  }
}